'use client'

import { useEffect, useState } from 'react'

import { Avatar, Box, Button, IconButton, Typography } from '@mui/material'
import UploadIcon from '@mui/icons-material/Upload'
import DeleteIcon from '@mui/icons-material/Delete'

const ImageUpload = ({ onImageUpload, name, imageProps, viewPage }) => {
  const [image, setImage] = useState(null)
  const [previewUrl, setPreviewUrl] = useState(null)

  useEffect(() => {
    if (imageProps) {
      setPreviewUrl(imageProps)
    }
  }, [imageProps])

  const handleImageChange = (e) => {
    const file = e.target.files[0]

    if (file && file.type.startsWith('image/')) {
      setImage(file)
      setPreviewUrl(URL.createObjectURL(file))
      onImageUpload(file, name)
    }
  }

  const handleRemoveImage = () => {
    setImage(null)
    setPreviewUrl(null)
  }

  return (
    <Box display='flex' flexDirection='row' alignItems='center' gap={3} justifyContent='start' sx={{ m: 4 }}>
      {previewUrl ? (
        <Box position='relative'>
          <Avatar
            src={previewUrl}
            alt='Preview'
            sx={{ width: 120, height: 120, objectFit: 'cover' }}
            variant='rounded'
          />
          {!viewPage && (
            <IconButton
              onClick={handleRemoveImage}
              sx={{
                position: 'absolute',
                top: -10,
                right: -10,
                backgroundColor: 'white',
                boxShadow: 1,
                '&:hover': {
                  backgroundColor: 'grey.100'
                }
              }}
            >
              <DeleteIcon color='error' />
            </IconButton>
          )}
        </Box>
      ) : (
        <>
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <Avatar sx={{ width: 120, height: 120, objectFit: 'cover' }} variant='rounded' />
            <Typography variant='body2'>No image selected</Typography>
          </Box>
        </>
      )}

      <Button
        component='label'
        variant='contained'
        color='inherit'
        startIcon={<UploadIcon color='white'/>}
        disabled={Boolean(previewUrl || image || viewPage)}
        sx={{ backgroundColor: '#0D1B5E', color: 'white', boxShadow: 1, '&:hover': { backgroundColor: '#0D1B5E' } }}
      >
        <span style={{ color: 'white' }}>Image</span>
        <input type='file' accept='image/*, .png, .jpg, .jpeg' hidden onChange={handleImageChange} />
      </Button>
    </Box>
  )
}

export default ImageUpload
